import { BILLBOARD, COMPLEX, REGION, PROPERTY, MARKET } from 'core/constants/report-type';
import { ExploreReportTypesDictionary } from 'features/explore/types/types';
import { PLMapboxMapIds } from 'pl-mapbox/use-pl-mapbox-map-state/initial-basemap-consts';
import { OverlayID } from 'ui-components/google-map-layers/types/google-map-layers-types';

export enum RestrictedItems {
    ENABLE_AVAILABLE_POIS = 'Available',
    ENABLE_CUSTOM_POIS = 'Custom POI',
    ENABLE_PRIVATE_MARKETS = 'Private',
    ENABLE_PUBLIC_MARKETS = 'Public',
    ENABLE_NEARBY_ACTIVITY_POIS = 'Nearby Activity',
    ENABLE_CLOSED_POIS = 'Closed',
}

export const MAX_AMOUNT_OF_RECENT_POIS = 6;

export const categoriesToExclude = ['Region'];
export const categoriesToKeep = ['Shopping District'];
export const hiddenCategories = ['Address', 'Country'];

export const FILTER_TYPE_LABELS = {
    [PROPERTY]: 'Properties',
    [BILLBOARD]: 'Traffic Pins',
    [COMPLEX]: 'Complexes',
    [REGION]: 'Regions/Markets',
    [MARKET]: 'Markets',
};

export const EMPTY_STATE_TITLES: ExploreReportTypesDictionary<string> = {
    Property: 'No Properties were found in map bounds.',
    Billboard: 'No Traffic Pins were found in map bounds.',
};

export const reportSplunkMapOverlay: Record<OverlayID, string> = {
    poi: 'Property',
    nearby: 'Nearby Activity',
    complex: 'Enclosing Property',
    market: 'Market',
};

export const COORDINATES_ENTITY = 'coordinate';

export const ADDRESS_ENTITY = 'address';

export const EXPLORE_SPLUNK_ID = 'explore';
export const EXPLORE_BASE_SPLUNK_EVENT = {
    view_name: EXPLORE_SPLUNK_ID,
};

export const MAP_ID = PLMapboxMapIds.EXPLORE;
